/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Company_TermsInputs */

const en_page_title_company_terms = /** @type {(inputs: Page_Title_Company_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of use for companies`)
};

const de_page_title_company_terms = /** @type {(inputs: Page_Title_Company_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen für Unternehmen`)
};

/**
* | output |
* | --- |
* | "Terms of use for companies" |
*
* @param {Page_Title_Company_TermsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const page_title_company_terms = /** @type {((inputs?: Page_Title_Company_TermsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Company_TermsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_page_title_company_terms(inputs)
	return en_page_title_company_terms(inputs)
});